var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hamburger",
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hamburger-1",
    d: "M31.875,26.875 L31.875,30 L8.125,30 L8.125,26.875 L31.875,26.875 Z M31.875,18.75 L31.875,21.875 L8.125,21.875 L8.125,18.75 L31.875,18.75 Z M31.875,11.25 L31.875,14.375 L8.125,14.375 L8.125,11.25 L31.875,11.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hamburger-3",
    transform: "translate(-1375.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hamburger-4",
    transform: "translate(40.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hamburger-5",
    transform: "translate(1327.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hamburger-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "hamburger-7",
    xlinkHref: "#hamburger-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "hamburger-8",
    fill: "#151515",
    fillRule: "evenodd",
    xlinkHref: "#hamburger-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger-9",
    className: "fill-selector",
    mask: "url(#hamburger-6)",
    fill: "#151515",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "hamburger-10",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.9c79437911d0ce2cbad0dc1f2ce4f588.svg";
export { ForwardRef as ReactComponent };